import { render, staticRenderFns } from "./QDataTableHeader.vue?vue&type=template&id=5e21a4c8&scoped=true&"
import script from "./QDataTableHeader.vue?vue&type=script&lang=ts&"
export * from "./QDataTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QDataTableHeader.vue?vue&type=style&index=0&id=5e21a4c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e21a4c8",
  null
  
)

export default component.exports